import LicenceAPI from '@/features/api/licence/licence'
import { logger } from '@/logger'
import { RootState } from '@/redux/store'
import { ThunkRejectValue } from '@/redux/types'
import { getThunkRejectValue } from '@/redux/utils'
import { ILicence } from '@/types/licence'
import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit'

interface LicenceState {
    licence: ILicence | null
}

const initialState: LicenceState = {
    licence: null,
}

export const createLicenceSlice = buildCreateSlice({
    creators: { asyncThunk: asyncThunkCreator },
})

const licenceSlice = createLicenceSlice({
    name: 'licence',
    initialState,
    reducers: (create) => {
        const createThunk = create.asyncThunk.withTypes<{ rejectValue: ThunkRejectValue }>()

        return {
            fetchLicence: createThunk<ILicence>(
                async (_, { rejectWithValue }) => {
                    try {
                        const licence = await LicenceAPI.fetchLicenceData()

                        logger.withContext({
                            tags: {
                                licenceId: licence.id,
                                licenceUrl: licence.url,
                                licenceName: licence.name,
                            },
                        })

                        return licence
                    } catch (e) {
                        logger
                            .withMetadata({ tags: { feature: 'licence' } })
                            .withError(e)
                            .error()

                        return rejectWithValue(getThunkRejectValue(e))
                    }
                },
                {
                    fulfilled: (state, { payload: licence }) => void (state.licence = licence),
                }
            ),
        }
    },
})

export const { fetchLicence } = licenceSlice.actions

export const licenceSelectors = {
    licence: ({ licence }: RootState) => licence.licence,
}

export default licenceSlice.reducer
